module.exports = __webpack_public_path__ + "img/1.208b5e6e.png";